module.exports = __webpack_public_path__ + "static/FC49_Letterhead-6b64f110319a55cd02ae0cc76df6b20b.png";